/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "./style.scss";
import React from "react";
import DeliveryPartnerList from "./DeliveryPartnerList/DeliveryPartnerList";
import Heading from "../../components/Heading";
import { useLocation } from "react-router-dom";

const DeliveryPartner = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const type = params.get("type");

  return (
    <div className="p-1">
      <Heading title={`Delivery Partner - ${type === "ECOMM" ? "Ecomm" : "Cargo"}`} />
      <div className="global-card-tab-container">
        <DeliveryPartnerList type={type} />
      </div>
    </div>
  );
};

export default DeliveryPartner;
